import CustomModal from "../../common/general/CustomModal/CustomModal";
import CustomText from "../../common/general/CustomText/CustomText";
import { Dispatch, SetStateAction } from "react";
import { File, StoragePathType } from "@axio/graphql/generated/graphql";
import { ResourceType } from "../../../contexts/ActiveCourseContext";
import StudentFileUpload from "../../customCoursework/StudentFileUpload/StudentFileUpload";
import CustomSpacing from "../../common/layout/CustomSpacing/CustomSpacing";

interface AddProjectFileModalProps {
  visible: boolean;
  onClose: () => void;
  fileState: [Partial<File>[], Dispatch<SetStateAction<Partial<File>[]>>];
  resource: { resourceType: ResourceType; resourceId: string };
  onSubmitFiles: () => Promise<void>;
}

const AddProjectFileModal = ({ visible, onClose, fileState, resource, onSubmitFiles }: AddProjectFileModalProps) => {
  return (
    <CustomModal visible={visible} onRequestClose={onClose} showCloseButton={true}>
      <CustomText text="You can upload relevant files to your project submission here." />
      <CustomSpacing size="l" />
      <StudentFileUpload
        resource={resource}
        filesState={fileState}
        storagePath={StoragePathType.ProjectSubmissions}
        onSubmitFiles={onSubmitFiles}
      />
    </CustomModal>
  );
};

export default AddProjectFileModal;
